import { User } from '../../clients/aasServerClient.generated';
import * as actionCreators from './actionCreators';
import { ActionTypeNames } from './actions';

export interface State {
    table: User[];
    all: User[];
    singleUser: {
        loaded: boolean;
        saved: boolean;
        user?: Partial<User>;
    };
    applicationKey: {
        key: string;
        users: string[];
        application: string;
    };
}

const initialState: State = {
    all: [],
    singleUser: {
        loaded: false,
        saved: false,
        user: undefined
    },
    table: [],
    applicationKey: {
        key: '',
        users: [],
        application: ''
    }
};

type Actions = ReturnType<typeof actionCreators[keyof typeof actionCreators]>;

export default function reducer(state: State = initialState, action: Actions): State {
    switch (action.type) {
        case ActionTypeNames.StoreTableUsers:
            return {
                ...state,
                table: action.users
            };
        case ActionTypeNames.StoreAllUsers:
            return {
                ...state,
                all: action.users,
            };
        case ActionTypeNames.ClearSingleUser:
            return {
                ...state,
                singleUser: {
                    loaded: false,
                    saved: false,
                    user: undefined
                },
            };
        case ActionTypeNames.StoreSingleUser:
            return {
                ...state,
                singleUser: {
                    loaded: true,
                    saved: false,
                    user: action.user
                },
            };
        case ActionTypeNames.SavedSingleUser:
            return {
                ...state,
                singleUser: {
                    ...state.singleUser,
                    saved: true,
                }
            };
        case ActionTypeNames.StoreUserApplicationKey:
            return {
                ...state,
                applicationKey: {
                    key: action.applicationKey,
                    users: action.userIds,
                    application: action.appId
                }
            };
        case ActionTypeNames.ResetUserApplicationKey:
            return {
                ...state,
                applicationKey: {
                    key: '',
                    users: [],
                    application: ''
                }
            };

        default:
            return state;
    }
}
